import styled from 'styled-components'
import { Body, Button, Spacer } from '@spritz-finance/ui'
import React, { useState } from 'react'
import { Row } from '../../components/Layout/Row'
import { Checkbox } from '../../components/Checkbox'
import { Link } from './components'
import { useSpritzCardInfoDialog } from './SpritzCardInfoDialog'

const IntroHeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    background: #e7faf4;
    border-radius: 10px;
    margin-bottom: 24px;
`

const BottomRow = styled(Row)`
    justify-content: space-between;
    width: 100%;
`

export const IntroHeader = () => {
    const { openDialog } = useSpritzCardInfoDialog()
    const key = 'spritzcardinfoheader'
    const didHide = !!localStorage.getItem(key)

    const [dontShow, setDontShow] = useState(false)
    const [hidden, setHidden] = useState(didHide)

    const hide = () => {
        setHidden(true)
        if (dontShow) {
            localStorage.setItem(key, 'true')
        }
    }

    if (hidden) return null

    return (
        <IntroHeaderWrapper>
            <Body.SmBold align="center">Your Spritz Card is set up!</Body.SmBold>
            <Spacer height={8} />
            <Body.SmBold align="center">
                It's time to fund your Spritz Card! Click fund with crypto to get started or
                <Link onClick={openDialog}>learn more</Link>
                about how it works.
            </Body.SmBold>
            <BottomRow>
                <div style={{ flexGrow: 1 }}>
                    <Row>
                        <Checkbox checked={dontShow} onChange={() => setDontShow(!dontShow)} />
                        <Spacer width={8} />
                        Don't show me again
                    </Row>
                </div>
                <Button.Text onClick={hide}>Got it!</Button.Text>
            </BottomRow>
        </IntroHeaderWrapper>
    )
}
